import { CgPerformance } from "react-icons/cg";
import { Button } from "@/components/ui/button/button";
import { usePerformanceLogModal } from "./use-performance-log-modal";
import { EmployeePerformanceLogsModal } from "./performance-log-modal";
// import { useCreatePerformanceLog } from "./create-performance-log/use-create-performance-log-modal";
// import { CreatePerformanceLog } from "./create-performance-log";

export const EmployeePerformanceLogs = () => {
  const { onOpenChange } = usePerformanceLogModal();

  // const { onOpenChange: onCreatePerformanceLog } = useCreatePerformanceLog();

  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Performance Logs</h2>

        <CgPerformance className="w-3 h-3" />
      </div>
      <div className=" justify-between flex items-center">
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>

        {/* <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            onCreatePerformanceLog(true);
          }}
        >
          + Add
        </Button> */}
      </div>

      <EmployeePerformanceLogsModal />
      {/* <CreatePerformanceLog /> */}
    </div>
  );
};
